// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5128":"276a4aff","7518":"3a3ecbff","9013":"e6e45389"}[chunkId] + ".chunk.css";
};